import { Alert } from '@mui/material';
import { convertUTCDateToEST } from '@/utils';

const DRAFT_INTAKE_DISCLAIMER =
    'This is draft intake information. It may not reflect the final state of the client’s submission.';

interface Props {
    draftLastUpdatedAt?: Date | string;
}

export default function DraftIntakeDisclaimer({ draftLastUpdatedAt }: Props) {
    const message = draftLastUpdatedAt
        ? `${DRAFT_INTAKE_DISCLAIMER} Last updated ${convertUTCDateToEST(
              draftLastUpdatedAt,
              'yyyy/M/d h:mm a',
          )}.`
        : DRAFT_INTAKE_DISCLAIMER;

    return <Alert severity="warning">{message}</Alert>;
}
